import { render, staticRenderFns } from "./DatosGeneralesComponent.vue?vue&type=template&id=11ae223d"
import script from "./DatosGeneralesComponent.vue?vue&type=script&lang=js"
export * from "./DatosGeneralesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports